import React, { ComponentType } from 'react';
import { inject, observer } from 'mobx-react';
import { DesktopNavigation } from './DesktopNavigation';
import { MobileNavigation } from './MobileNavigation';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import { NavigationState, NavigationType } from '../../states/NavigationState';
import { SimpleDesktopNavigation } from './application/SimpleDesktopNavigation';
import { SimpleMobileNavigation } from './application/SimpleMobileNavigation';
import { BeautyLogo } from '../../../commonv3/components/atoms/logos/BeautyLogo';
import { BeautyRoutes, MoneyRoutes } from '../../routes';
import { MoneyLogo } from '../../../commonv3/components/atoms/logos/MoneyLogo';
import { DesktopSideNavigation } from './DesktopSideNavigation';
import { MobileSideNavigation } from './MobileSideNavigation';

type Props = {
  navigationState: NavigationState;
};

const _Navigation = inject('navigationState')(
  observer(
    class _Navigation extends React.Component<Props> {
      render() {
        const {
          navigationState: { currentSpec },
        } = this.props;
        switch (currentSpec.type) {
          case NavigationType.HOME:
            return GlobalStatesV3.viewport.isDesktop ? (
              <DesktopNavigation background={currentSpec.background} />
            ) : (
              <MobileNavigation background={currentSpec.background} showMainMenu={currentSpec.showMainMenu} />
            );
          case NavigationType.APPLICATION:
            return GlobalStatesV3.viewport.isDesktop ? <SimpleDesktopNavigation /> : null;
          case NavigationType.STANDARD:
            return GlobalStatesV3.viewport.isDesktop ? <SimpleDesktopNavigation /> : <SimpleMobileNavigation />;
          case NavigationType.BEAUTY: {
            const Logo = (props) => (
              <BeautyLogo {...props} onClick={() => (location.href = BeautyRoutes.home().pathname)} />
            );
            return GlobalStatesV3.viewport.isDesktop ? (
              <SimpleDesktopNavigation logo={Logo} showNotificationIcon={false} />
            ) : (
              <SimpleMobileNavigation logo={Logo} showNotificationIcon={false} />
            );
          }
          case NavigationType.MONEY: {
            const Logo = (props) => (
              <MoneyLogo {...props} onClick={() => (location.href = MoneyRoutes.home().pathname)} />
            );
            return GlobalStatesV3.viewport.isDesktop ? (
              <SimpleDesktopNavigation logo={Logo} />
            ) : (
              <SimpleMobileNavigation logo={Logo} />
            );
          }
          case NavigationType.SIDE: {
            return GlobalStatesV3.viewport.isDesktop ? <DesktopSideNavigation /> : <MobileSideNavigation />;
          }
          case NavigationType.NONE:
            return null;
        }
      }
    }
  )
);

export const Navigation = _Navigation as ComponentType;
